import { Media } from '@/types/contentServerContract';

function extensionIsGifOrUndefined(file:Media|undefined): 'gif' | undefined {
    return file?.extension === 'gif' ? 'gif' : undefined;
}
export {
    extensionIsGifOrUndefined
};
